export const WorkplaceCockpitRoutes = {
  all: () => '/office/cockpits/workplace-cockpits',
  sharedCockpit: (workplaceNo) => `/office/shared/workplace-cockpit/${workplaceNo}`,
};
